import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b58fb918"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-faq" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "section-title" }, " FAQ ", -1))
const _hoisted_4 = { class: "name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1))
const _hoisted_6 = { class: "collapse-title" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "faq-content" }


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const tabs = [
    {
      name: '참여 신청',
      faqs: [
        {
          title: '가플지우 캠페인은 무엇인가요?',
          content: [
            {
              text: '가플지우는 ‘가져와요 플라스틱 지켜가요 우리바다\'의 줄임말로 플라스틱 폐기물 감축 및 해양환경 보호를 위한 소비자 참여형 캠페인입니다. 이번 캠페인을 통해 서울, 경기, 인천 지역 이마트 수도권 전 점포에 설치된 플라스틱 회수함뿐만 아니라 온라인에서도 재활용이 어려운 플라스틱을 회수합니다. 소비자들이 모아준 플라스틱은 테라사이클의 재활용 공정을 통해 재생 원료로 재탄생됩니다.'
            }
          ]
        },
        {
          title: '신청이 완료되었는지 어떻게 확인하나요?',
          content: [
            {
              text: '신청이 완료되면 등록하신 핸드폰 번호로 카카오톡 알림 메시지가 발송되며 마이페이지에서 확인할 수 있습니다.'
            }
          ]
        },
        {
          title: '신청인 정보를 수정하고 싶습니다. (주소지/연락처 등)',
          content: [
            {
              text: '신청인 정보 변경은 테라사이클 카카오톡 채널로 아이디/성함/휴대폰 번호를 기재 후 문의하시면 확인 후 도와드리겠습니다.'
            }
          ]
        },
        {
          title: '한 사람당 몇 번까지 참여 가능한가요?',
          content: [
            {
              text: '해양 환경을 지키기 위한 마음이 있다면 누구나 언제든 수거에 참여하실 수 있습니다. 다만, 환경을 위해 최대한 많은 양의 플라스틱이 모였을 때 신청해 주시기 바랍니다.'
            },
            {
              text: '*온라인 외에도 이마트 오프라인 점포 약 79개 매장에 설치된 회수함에서도 참여할 수 있습니다.'
            }
          ]
        },
        {
          title: '참여 취소 신청은 어떻게 하나요?',
          content: [
            {
              text: '온라인 수거 캠페인 취소 신청을 원하시면 테라사이클 카카오톡 채널로 아이디/성함/휴대폰 번호를 기재 후 문의하시면 확인 후 도와드리겠습니다.'
            }
          ]
        }
      ]
    },
    {
      name: '수거 신청',
      faqs: [
        {
          title: '수거 신청 후 기사님이 언제 방문하시나요?',
          content: [
            {
              text: '평일 3~4일 이내에 신청하신 주소로 택배 기사님께서 방문하실 예정입니다.'
            }
          ]
        },
        {
          title: '수거 시 택배 비용은 본인 부담인가요?',
          content: [
            {
              text: '박스 수거는 무료입니다. \'수거 신청하기\' 버튼을 누르신 후 보내실 플라스틱에 맞는 박스에 담아 문 앞에 놓아주시면 택배사에서 방문하여 수거할 예정입니다.'
            }
          ]
        },
        {
          title: '어떤 플라스틱이 수거 가능한가요?',
          content: [
            {
              text: '샴푸/세제/분무기 통/칫솔, 즉석밥 용기, 브리타 필터, 투명 음료 페트병 모두 수거 가능합니다.'
            }
          ]
        },
        {
          title: '신청 후 기사님 방문 전 취소가 가능한가요?',
          content: [
            {
              text: '네, 수거 신청을 취소하는 것은 가능합니다. 다만, 실수로 신청 버튼을 누르신 경우에 테라사이클 카카오톡 채널로 취소 요청을 남겨 주셔야 합니다. 당일 취소를 하지 못하신 경우에는 택배 기사님과 따로 연락하시어 취소 요청을 말씀드리면 됩니다.'
            }
          ]
        }
      ]
    },
    {
      name: '재활용',
      faqs: [
        {
          title: '수거한 플라스틱은 어디에 사용되나요?',
          content: [
            {
              text: '소비자들이 모아준 플라스틱은 테라사이클의 재활용 공정을 통해 재질별 분류 후 새로운 재활용 원료로 재탄생하게 됩니다. 이는 새로운 제품으로 재탄생되어 지역사회에 기부됩니다.'
            }
          ]
        },
        {
          title: '테라사이클은 어떤 기업인가요?',
          content: [
            {
              text: '\'테라사이클\'은 글로벌 재활용 컨설팅 기업으로 다양한 기업들과 협력하여 버려지는 폐기물을 재활용할 수 있도록 기획하고 실행하는 기업입니다.'
            }
          ]
        },
        {
          title: '택배를 이용하는 것은 환경에 안 좋지 않을까요? ',
          content: [
            {
              text: '플라스틱을 수거하여 올바르게 재활용하면 소각, 매립할 때보다 환경에 미치는 부정적 영향을 더 줄일 수 있습니다.'
            },
            {
              text: '환경을 생각하는 마음을 담아 되도록 한 번에 많은 양의 플라스틱을 모아 수거 신청해주세요.'
            },
            {
              text: '플라스틱을 줄이는 것만큼이나 잘 재활용될 수 있도록 하는 것도 중요하니 가플지우 캠페인을 통해 올바른 플라스틱 분리배출에 대해 함께 생각하고 실천해주세요!'
            }
          ]
        }
      ]
    }
  ];

return (_ctx: any,_cache: any) => {
  const _component_AppCollapse = _resolveComponent("AppCollapse")!
  const _component_AppTab = _resolveComponent("AppTab")!
  const _component_AppTabs = _resolveComponent("AppTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_AppTabs, { class: "faq-tabs" }, {
        trigger: _withCtx((scope) => [
          _createElementVNode("div", {
            class: _normalizeClass(["faq-tab-item", { active: scope.active }])
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(scope.label), 1)
          ], 2)
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
            return _createVNode(_component_AppTab, {
              key: tab.name,
              label: tab.name
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.faqs, (faq, index) => {
                  return (_openBlock(), _createBlock(_component_AppCollapse, {
                    key: index,
                    class: "faq-collapse"
                  }, {
                    trigger: _withCtx(({ visible }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                      }, [
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, _toDisplayString(faq.title), 1),
                        _createElementVNode("img", {
                          class: "indicator",
                          src: require('./images/btn-arrow-down.png')
                        }, null, 8, _hoisted_7)
                      ], 2)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.content, (item, contentIndex) => {
                          return (_openBlock(), _createElementBlock("div", { key: contentIndex }, _toDisplayString(item.text), 1))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 2
            }, 1032, ["label"])
          }), 64))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})